import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, renderList as _renderList, unref as _unref, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "dialog-content pt-6" }
const _hoisted_2 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_3 = { class: "flexColumn" }
const _hoisted_4 = {
  key: 2,
  class: "checkbox-group"
}
const _hoisted_5 = { class: "checkbox-group__label" }
const _hoisted_6 = {
  key: 2,
  class: "dialog-content pb-6"
}

import { formApi } from '@/api/form';
import { useDialogStore } from '@/stores/dialogs';
import { computed, nextTick, onMounted, reactive, ref, watch } from 'vue';
import { useErrors } from '@/utils/use-errors';
import { useProgramsStore } from '@/stores/programs';
import { useAccountStore } from '@/stores/account';
import VStepper from '../VStepper.vue';
import SuccesDialog from './SuccesDialog.vue';
import VDialogHeader from './VDialogHeader.vue';
import formData from '@/utils/test.json'
import VYesNoButton from '../VYesNoButton.vue';
import VFullRadioGroup from '@/components/VFullRadioGroup.vue';
import dayjs from 'dayjs';
import VDatePicker from '../VDatePicker.vue';

type Column = { id: string, name: string, type: string, choises?: { [key: string]: string }, info?: { [key: string]: string } }

export default /*#__PURE__*/_defineComponent({
  __name: 'CreateReportDialog',
  props: {
    report: null
  },
  setup(__props: any) {

const props = __props as { report?: any }

const status = ref("init")



const items = reactive<{ name: string, columns: Column[] }[]>([])

const values = reactive<{ [key: string]: any }>({})

let initialFields: any = {}
let multiselectFields: string[] = []
onMounted(async () => {
  const formData = await formApi.getFormData("shrXA3a81qUCTigZm")
  status.value = "loaded"
  const keys = new Set()
  let page: typeof items[0] = { name: "", columns: [] }

  for (let data of formData.columns) {
    const name = data.metadata?.title || data.name
    const type = data.type
    const id = data.name
    const column: Column = { id, name, type  }
    keys.add(id)

    const tags = (data.metadata?.description || "")
    if (tags) {
      const newPage = tags.match(/new-page "(.+?)"/)
      if (newPage) {
        page = { name: newPage[1], columns: [] }
        items.push(page)
      } 
      if (tags.includes("/yes-no-button")) {
        column.type = "yes-no-button"
      }
      if (tags.includes("/diary-score")) {
        column.info = {
          "3": "Не заполнили",
          "4": "Заполнили, но некачественно",
          "5": `Качественное заполнение дневника: все блоки заполнены, сделаны выводы, есть ссылки на фактуру, видна причинно-следственная связь цели на спринт-что сделали-какие выводы-что дальше думаем делать`
        }
      }
      if (tags.includes("/execution-score")) {
        column.info = {
          "3": "Цель спринта не доcтигнута. Совсем не делали что планировали",
          "4": "Делали что планировали, но не достигли целей спринта",
          "5": "Достигли целей спринта",
          "6": "Достигли цели спринта и сделали, что даже не планировали",
        }
      }
      if (tags.includes("/custom-date")) {
        column.type = "custom-date"
      }
    }
    if (data.typeOptions?.choices) {
      let arr = data.typeOptions.choiceOrder.map((id: string) => [ id, data.typeOptions.choices[id].name ] )
      const initialValue = arr.find((item: any) => item[1] === "1")
      if (initialValue) {
        initialFields[id] = initialValue[0]
        arr = arr.filter((item: any) => item[1] !== "1" && item[1] !== "2" )
      }
      column.choises = Object.fromEntries(arr)
    }
    if (type === 'foreignKey') {
      multiselectFields.push(id)
    }
    page.columns.push(column)
    
    if (type === "multiSelect") {
      values[column.id] = []
    }
  }
  if (props.report) {
    values['Программа'] = props.report.programId
    await nextTick()
    values['Команда'] = props.report.teamId
    await nextTick()
    for (let [key, value] of Object.entries(props.report.fields)) {
      if (!keys.has(key)) continue
      values[key] = value
    }
    values['Оценка за дневник'] = props.report.diaryScore.toString()
    values['Оценка за Execution'] = props.report.diaryScore.toString()
    values['Запрос на ресурсы'] = props.report.resourceRequest
    values['Дата ТМ'] = props.report.tmDate && dayjs(props.report.tmDate).format("DD.MM.YYYY")
    for (let item of items) {
      for (let column of item.columns) {
        if (column.choises && column.id in values) {
          values[column.id] = Object.entries(column.choises).find(i => i[1] === values[column.id])![0]
        }
      }
    }
  }
})

const checkboxes = ref<string[]>()
const checkboxesId = ref<string>()
watch(() => values[checkboxesId.value!]?.length, () => {
  const arr = values[checkboxesId.value!]
  if (!arr || !checkboxes.value || checkboxes.value.length === 0 || arr.length === 0) return
  for (let id of checkboxes.value) {
    if (!arr.includes(id)) {
      values["Новая контрольная точка"] = currentProgramStageId.value
      return
    }
  }
  const index = programsStore.stages.findIndex(i => i.id === currentProgramStageId.value)
  const nextStage = programsStore.stages[Math.min(index+1, programsStore.stages.length)].id
  values["Новая контрольная точка"] = nextStage
})

const disabled = new Set<string>()
const requestTeamChecklist = async () => {
  const teamId = values["Команда"]
  const resp = await formApi.getCheckList(teamId)
  const page = items.find(page => page.columns.find(item => item.name === "Цели этапа" || item.name === "Качественные цели этапа"))
  if (!page) return
  const index = page.columns.findIndex(item => item.name === "Цели этапа" || item.name === "Качественные цели этапа")
  const id = page.columns[index].id
  checkboxesId.value = id
  const quality = {
    id,
    name: "Качественные цели этапа",
    type: "multiSelect",
    choises: Object.fromEntries(resp.checklist.filter((item: any) => item.type === "quality").map((item: any) => [ item.id, item.title ]))
  }
  const quantity = {
    id,
    name: "Количественные цели этапа",
    type: "multiSelect",
    choises: Object.fromEntries(resp.checklist.filter((item: any) => item.type === "quantity").map((item: any) => [ item.id, item.title ]))
  } 
  checkboxes.value = resp.checklist.map((item: any) => item.id)
  page.columns = page.columns.filter(item => item.id !== id)
  page.columns.splice(index, 0, quality, quantity)

  if (props.report) {
    values[id] = props.report.stageTasks.map((item: any) => item.id)
  } else {
    values[id] = resp.lastReport?.stageTasks?.map((item: any) => item.id) || []
  }
  values["План"] = resp.lastReport?.fields["Цель на новый спринт"] || ""

  if (!values["План"] || values["План"].length < 1) {
    disabled.delete("План")
  } else {
    disabled.add("План")
  }

  values[id] = values[id].filter((item: any) => item in quality.choises || item in quantity.choises)
}

const step = ref(1)
const stepBack = () => {
  if (step.value === 1) {
    dialogStore.close()
    return
  }
  step.value--
}

const errors = useErrors(values)

const ignore = [ "Запрос на ресурсы", "Запрос на смену контрольной точки", "Дата ТМ" ]
const stepForward = (stepForward = true) => {
  let hasError = false
  for (let column of items[step.value-1].columns) {
    if (!values[column.id] && !ignore.includes(column.id)) {
      errors[column.id] = "Поле обязательно к заполнению"
      hasError = true
    }
  }
  if (values["Дата ТМ"] && !dayjs(values["Дата ТМ"], "DD.MM.YYYY").isValid()) {
    errors["Дата ТМ"] = "Неверный формат даты"
    hasError = true
  }
  if (hasError) {
    console.log(errors)
    return false
  }
  if (stepForward) {
    step.value++
  }
  if (stepForward && step.value === 2) {
    requestTeamChecklist()
  }
  return true
}

const accountStore = useAccountStore()
const programsStore = useProgramsStore()
const teams = ref()
watch(() => values["Программа"], (programId) => {
  if (!programId) return
  const program = programsStore.programs.find(item => item.id === programId)
  teams.value = program?.teams || []
  teams.value = teams.value.filter((team: any) => team.trackerId == accountStore.currentUser!.id)
  if (values["Команда"] && !teams.value.find((item: any) => item.id === values["Команда"])) {
    delete values["Команда"]
  }
})

const team = computed(() => {
  const program = programsStore.programs.find(item => item.id === values["Программа"])
  if (!program) return null
  const team = program.teams.find(team => team.id === values["Команда"])
  return team || null
})

const currentProgramStageId = ref<string>()
watch(team, (team) => {
  if (!team) return
  currentProgramStageId.value = team.programStageId
  values["Новая контрольная точка"] = team.programStageId
})

const hadMeeting = computed(() => {
  const val = values['Состоялась ли встреча с командой']
  const column = items[0].columns.find(item => item.id === 'Состоялась ли встреча с командой')

  if (!val) return true
  if (column!.choises![val] === 'Нет') return false
  return true
})

const getSelectItems = (name: string) => {
  if (name === "Программа") {
    return programsStore.programs
  }
  if (name === "Команда" || name === "Название команды") {
    return teams.value
  }
  if (name === "Новая контрольная точка") {
    return programsStore.stages
  }
  return []
}

const pending = ref(false)
const dialogStore = useDialogStore()
const submit = async () => {
  console.log(values)
  if (stepForward(false) === false) return
  pending.value = true
  try {
    const _values = { ...values }
    if (_values["Дата ТМ"]) {
      _values["Дата ТМ"]= dayjs(_values["Дата ТМ"], "DD.MM.YYYY").toISOString()
    } else {
      delete _values["Дата ТМ"]
    }
    if (!hadMeeting.value) {
      for (let i = 1; i < items.length; i++) {
        for (let column of items[i].columns) {
          delete _values[column.id]
          if (column.id in initialFields) {
            _values[column.id] = initialFields[column.id]
          }
        }
      }
    }
    for (let [ name, value ] of Object.entries(_values)) {
      if (multiselectFields.includes(name) && !Array.isArray(value)) {
        _values[name] = [ value ]
      }
    }

    if (props.report) {
      await formApi.sendFormEdit(props.report.id, _values)
      dialogStore.open(SuccesDialog, { title: "Отчет сохранен", content: "Данные обновлены" })
    } else {
      await formApi.sendForm(_values)
      if (hadMeeting.value === false) {
        dialogStore.open(SuccesDialog, { title: "Отчет отправлен", content: "Жаль, что встреча не состоялась" })
      } else {
        dialogStore.open(SuccesDialog, { title: "Отчет отправлен", content: "Спасибо за проделанную работу!" })
      }
    }

    const _team = team.value
    if (_team) {
      setTimeout(() => {
        programsStore.requestReports(_team)
      }, 1500)
    }
  } catch(e) {
    pending.value = false
    console.log(e)
  }
}


return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(VDialogHeader, null, {
      default: _withCtx(() => [
        (props.report)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode("Редактирование отчета")
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode("Создание отчета")
            ], 64))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(VStepper, {
        modelValue: step.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((step).value = $event)),
        steps: items.map(item => item.name),
        class: "pb-6"
      }, null, 8, ["modelValue", "steps"])
    ]),
    (status.value === 'init')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "primary"
          })
        ]))
      : (_openBlock(), _createBlock(_component_v_window, {
          key: 1,
          modelValue: step.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((step).value = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (page, index) => {
              return (_openBlock(), _createBlock(_component_v_window_item, {
                value: index+1,
                class: "px-6 pt-2"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.columns, (column) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      (column.type === 'foreignKey')
                        ? (_openBlock(), _createBlock(_component_v_select, {
                            key: 0,
                            modelValue: values[column.id],
                            "onUpdate:modelValue": ($event: any) => ((values[column.id]) = $event),
                            "error-messages": _unref(errors)[column.id],
                            items: getSelectItems(column.name),
                            label: column.name,
                            "item-title": "name",
                            "item-value": "id",
                            variant: "outlined"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "error-messages", "items", "label"]))
                        : (column.type === 'select')
                          ? (_openBlock(), _createBlock(VFullRadioGroup, {
                              key: 1,
                              label: column.name,
                              tooltips: column.info,
                              items: column.choises!,
                              modelValue: values[column.id],
                              "onUpdate:modelValue": ($event: any) => ((values[column.id]) = $event),
                              "error-messages": _unref(errors)[column.id]
                            }, null, 8, ["label", "tooltips", "items", "modelValue", "onUpdate:modelValue", "error-messages"]))
                          : (column.type === 'multiSelect')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, _toDisplayString(column.name), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.choises, (name, key) => {
                                  return (_openBlock(), _createBlock(_component_v_checkbox, {
                                    modelValue: values[column.id],
                                    "onUpdate:modelValue": ($event: any) => ((values[column.id]) = $event),
                                    label: name,
                                    value: key,
                                    "hide-details": ""
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "value"]))
                                }), 256))
                              ]))
                            : (column.type === 'yes-no-button')
                              ? (_openBlock(), _createBlock(VYesNoButton, {
                                  key: 3,
                                  modelValue: values[column.id],
                                  "onUpdate:modelValue": ($event: any) => ((values[column.id]) = $event),
                                  label: column.name,
                                  style: _normalizeStyle({ display: values['Новая контрольная точка'] !== currentProgramStageId.value? 'block': 'none' })
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "style"]))
                              : (column.type === 'custom-date')
                                ? (_openBlock(), _createBlock(VDatePicker, {
                                    key: 4,
                                    modelValue: values[column.id],
                                    "onUpdate:modelValue": ($event: any) => ((values[column.id]) = $event),
                                    label: column.name
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                                : (column.type === 'multilineText')
                                  ? (_openBlock(), _createBlock(_component_v_textarea, {
                                      key: 5,
                                      modelValue: values[column.id],
                                      "onUpdate:modelValue": ($event: any) => ((values[column.id]) = $event),
                                      rows: "2",
                                      "auto-grow": "",
                                      variant: "outlined",
                                      label: column.name,
                                      color: "primary",
                                      "error-messages": _unref(errors)[column.id],
                                      disabled: _unref(disabled).has(column.id)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "error-messages", "disabled"]))
                                  : (_openBlock(), _createBlock(_component_v_text_field, {
                                      key: 6,
                                      modelValue: values[column.id],
                                      "onUpdate:modelValue": ($event: any) => ((values[column.id]) = $event),
                                      variant: "outlined",
                                      label: column.name,
                                      "error-messages": _unref(errors)[column.id]
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "error-messages"]))
                    ]))
                  }), 256))
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 256))
          ]),
          _: 1
        }, 8, ["modelValue"])),
    (status.value === 'loaded')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_v_btn, {
            color: "primary",
            onClick: stepBack,
            variant: "tonal",
            class: "mr-2"
          }, {
            default: _withCtx(() => [
              (step.value === 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("Отменить")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("Назад")
                  ], 64))
            ]),
            _: 1
          }),
          (step.value === items.length || !_unref(hadMeeting))
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                color: "primary",
                disabled: pending.value,
                onClick: submit
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Отправить отчет")
                ]),
                _: 1
              }, 8, ["disabled"]))
            : (_openBlock(), _createBlock(_component_v_btn, {
                key: 1,
                color: "primary",
                onClick: stepForward
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Далее")
                ]),
                _: 1
              }))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})